import { z } from 'zod';

/**
 * The Conversations section's URL search (`features/website-conversations/technical.md`,
 * Routing): the page number, anything that isn't a whole number from 1 up being
 * page 1 (`patterns/frontend-conventions.md`, 1). Page 1 is left out of the URL.
 *
 * `page` is always returned, as `undefined` for page 1, because the router
 * spreads this result over the URL's raw search: leaving the key out would let
 * a raw `page=abc` through to the section.
 */
export interface ConversationsSearch {
  // Optional, so links can leave it out; the parser always sets the key.
  page?: number | undefined;
}

const pageSchema = z.coerce.number().int().min(1).optional().catch(undefined);

export function parseConversationsSearch(search: Record<string, unknown>): ConversationsSearch {
  const page = pageSchema.parse(search['page']);
  return { page: page === 1 ? undefined : page };
}

/** The search for a page, leaving page 1 out of the URL. */
export function searchForPage(page: number): { page?: number } {
  return page === 1 ? {} : { page };
}
